<div class="overview-item">
  <span class="title">{{ 'STATISTICS.VACANCY_HEADER' | translate }}</span>
  <div class="vacancies-content">
    <div class="d-flex justify-content-center">
      <div class="chart" #chart>
        <div class="category-i text-align-center">
          <i class="d-block mb-3" [ngClass]="categoryIcon"></i>
          <span class="share">{{ share }}%</span>
        </div>
      </div>
    </div>
    <div class="row legend">
      <div class="legend-item">
        <div class="marker-container">
          <span class="marker vacant"></span>
        </div>
        <div class="value">
          <span>{{ 'STATISTICS.VACANT_TEXT' | translate }}</span>
          <span class="legend-amount">{{ vacant }}</span>
        </div>
      </div>
      <div class="legend-item">
        <div class="marker-container">
          <span class="marker rented"></span>
        </div>
        <div class="value">
          <span>{{ 'STATISTICS.RENTED_TEXT' | translate }}</span>
          <span class="legend-amount">{{ rented }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
